import { useTranslations } from "@i18n/next";
import { CommunityType } from "@packages/sdk";

export const RemoveActionText = ({
  communityType,
  isSelf = false,
}: {
  communityType: CommunityType;
  isSelf?: boolean;
}) => {
  const t = useTranslations();

  if (isSelf) return t("community_member_option_leave_group");

  if (
    [
      CommunityType.religious_ed_class,
      CommunityType.religious_ed_program,
    ].includes(communityType)
  )
    return t("general_word_remove_action");

  return t("community_member_option_remove");
};
